var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styled from 'styled-components';
import Loading from '@doordash/component-loading';
import { Text, Stack, Spacing, InlineChildren, StackChildren, } from '@doordash/design-language';
import * as yup from 'yup';
import useConfigureVgs from '../../../../Billing/PaymentCard/Vgs/useConfigureVgs';
import useVgsForm from '../../../../Billing/PaymentCard/Vgs/useVgsForm';
import { VgsFormFieldName, } from '../../../../Billing/PaymentCard/Vgs/Types/vgsCollect';
import { captureVgsEvent, VgsEvents, } from '../../../../Billing/PaymentCard/Vgs/vgsUtils';
import { QuickStartPageData } from '../../EmOnboardingPageData';
import { PaymentInputField } from './PaymentInputField';
var strings = QuickStartPageData.paymentForm;
var trackingViewName = 'quick-start';
var FieldContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: ", ";\n  overflow: hidden;\n"], ["\n  flex: ",
    ";\n  overflow: hidden;\n"])), function (props) {
    return props.isFullWidth ? "2" : "1";
});
var VgsInputContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  height: ", "px;\n  line-height: ", "px;\n  overflow: hidden;\n"], ["\n  display: flex;\n  height: ", "px;\n  line-height: ", "px;\n  overflow: hidden;\n"])), Spacing.Medium, Spacing.Medium);
export var initialPaymentFormValues = {
    isPaymentMethodValid: false,
};
export var paymentFormValidationSchema = {
    isPaymentMethodValid: yup.boolean().required().oneOf([true]),
};
export var PaymentForm = function (_a) {
    var submitting = _a.submitting, teamAccountId = _a.teamAccountId, paymentCardTracking = _a.paymentCardTracking, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    var _b = __read(useConfigureVgs(), 3), isVgsLoaded = _b[0], vgsLoadErrorMsg = _b[1], vgsConfig = _b[2];
    var formSubmit = useVgsForm(isVgsLoaded, teamAccountId).formSubmit;
    var _c = __read(React.useState(false), 2), isPaymentMethodSubmitting = _c[0], setIsPaymentMethodSubmitting = _c[1];
    var _d = __read(React.useState({
        inlineErrors: {},
        globalError: undefined,
    }), 2), formSubmitErrors = _d[0], setFormSubmitErrors = _d[1];
    var handleSubmit = function () {
        // Reset loading and errors.
        setIsPaymentMethodSubmitting(true);
        setFormSubmitErrors({ inlineErrors: {}, globalError: undefined });
        // Payment method processing
        formSubmit(handleSubmitSuccess, handleSubmitFailure);
    };
    var handleSubmitSuccess = function () {
        setIsPaymentMethodSubmitting(false);
        paymentCardTracking.onSuccess(null, 'vgs', {
            teamAccountId: teamAccountId,
            view: trackingViewName,
        });
        if (onSuccess) {
            onSuccess();
        }
    };
    var handleSubmitFailure = function (errors) {
        var _a;
        setFormSubmitErrors(errors);
        setIsPaymentMethodSubmitting(false);
        if (errors.globalError) {
            var reason = errors.globalError.reason;
            var message = errors.globalError.message;
            paymentCardTracking.onFailure(reason, message, 'vgs', {
                view: trackingViewName,
            });
            captureVgsEvent(VgsEvents.AddVgsCardForm, { vgsConfig: vgsConfig, errors: (_a = errors.globalError) === null || _a === void 0 ? void 0 : _a.originalException }, new Error(message));
        }
        else {
            var message = JSON.stringify(errors.inlineErrors);
            paymentCardTracking.onFailure('vgs_validation_failure', message, 'vgs', {
                view: trackingViewName,
            });
        }
        if (onFailure) {
            onFailure();
        }
    };
    React.useEffect(function () {
        if (submitting) {
            // submit button outside Payment Form is clicked
            handleSubmit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitting]);
    if (vgsLoadErrorMsg) {
        captureVgsEvent(VgsEvents.AddVgsCardForm, { vgsConfig: vgsConfig }, new Error(vgsLoadErrorMsg));
        return (React.createElement(Text, { color: Text.Colors.TextError, styles: Text.Styles.Bold16 }, vgsLoadErrorMsg));
    }
    else if (!isVgsLoaded) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(StackChildren, null,
        React.createElement(InlineChildren, null,
            React.createElement(FieldContainer, { isFullWidth: true },
                React.createElement(PaymentInputField, { labelName: strings.cardNumber.label, description: strings.cardNumber.description, error: formSubmitErrors.inlineErrors[VgsFormFieldName.Number] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-number" })))),
        React.createElement(InlineChildren, null,
            React.createElement(FieldContainer, null,
                React.createElement(PaymentInputField, { labelName: strings.cardExpiration.label, error: formSubmitErrors.inlineErrors[VgsFormFieldName.Expiration] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-expiration-date" }))),
            React.createElement(FieldContainer, null,
                React.createElement(PaymentInputField, { labelName: strings.cvv.label, error: formSubmitErrors.inlineErrors[VgsFormFieldName.CVC] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-cvc" }))),
            vgsConfig.ZIP_REQUIRED && (React.createElement(FieldContainer, null,
                React.createElement(PaymentInputField, { labelName: strings.zipCode.label, error: formSubmitErrors.inlineErrors[VgsFormFieldName.Zip] || '' },
                    React.createElement(VgsInputContainer, { id: "cc-zip" }))))),
        React.createElement(Stack, null),
        !isPaymentMethodSubmitting && formSubmitErrors.globalError && (React.createElement(Text, { color: Text.Colors.TextError }, formSubmitErrors.globalError.displayMsg))));
};
var templateObject_1, templateObject_2;
